import React from 'react'

export default ({ width=19 }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <path fill='#fff' d="M 8 0C 3.58921 0 0 3.58849 0 8C 0 12.4115 3.58921 16 8 16C 12.4108 16 16 12.4115 16 8C 16 3.58849 12.4108 0 8 0ZM 8 15.1011C 4.08431 15.1011 0.898876 11.9157 0.898876 8C 0.898876 4.08431 4.08431 0.898876 8 0.898876C 11.9157 0.898876 15.1011 4.08431 15.1011 8C 15.1011 11.9157 11.9157 15.1011 8 15.1011ZM 8 1.94733C 7.75141 1.94733 7.55056 2.14817 7.55056 2.39676L 7.55056 7.55056L 3.59551 7.55056C 3.34691 7.55056 3.14607 7.75141 3.14607 8C 3.14607 8.24859 3.34691 8.44944 3.59551 8.44944L 8 8.44944C 8.24859 8.44944 8.44944 8.24859 8.44944 8L 8.44944 2.39676C 8.44944 2.14887 8.24859 1.94733 8 1.94733Z"/>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/visuals/Clock.js